import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class NotificationsProvider {
  constructor(public storage: Storage) {
    
  }

  isRead(storageKey, id) {
    return this.getAllRead(storageKey).then(result => {
      return result && result.indexOf(id) !== -1;
    });
  }
 
  setRead(storageKey, id) {
    return this.getAllRead(storageKey).then(result => {
      if (result) {
        result.push(id);
        return this.storage.set(storageKey, result);
      } else {
        return this.storage.set(storageKey, [id]);
      }
    });
  }
 
  setUnread(storageKey, id) {
    return this.getAllRead(storageKey).then(result => {
      if (result) {
        var index = result.indexOf(id);
        result.splice(index, 1);
        return this.storage.set(storageKey, result);
      }
    });
  }
 
  getAllRead(storageKey) {
    return this.storage.get(storageKey);
  }
}


// WEBPACK FOOTER //
// ./src/providers/notifications/notifications.ts